// Actions
import { IDisplayResultValue } from '../../models/display-result.model';
import { ProductActions, ProductActionTypes } from './_actions';


// Models
export interface ProductState {
  productResults: IDisplayResultValue[];
  selectedProductItem: IDisplayResultValue;
}

export const initialProductState: ProductState = {
  productResults: null,
  selectedProductItem: null
};



export function ProductReducer(state = initialProductState, action: ProductActions): ProductState {
  switch (action.type) {
    case ProductActionTypes.SetProductsResults: {
      console.log('ProductReducer SetProductsResults', action.payload.results, state);
      return {
        ...state,
        productResults: action.payload.results
      };
    }
    case ProductActionTypes.SetSelectedProductItem: {
      const productIndex = state.productResults.findIndex(x => x.productCode === action.payload.product.productCode);
      return {
        ...state,
        selectedProductItem: state.productResults[productIndex]
      };
    }
    default: {
      return state;
    }
  }
}
